window.MarguetProductCards = window.MarguetProductCards || {
  init: function() {
    // Conservé pour compatibilité avec les appels existants.
    // Les clics sont maintenant gérés en délégation globale.
  }
};

if (!window.__marguetProductCardDelegationInstalled) {
  window.__marguetProductCardDelegationInstalled = true;

  document.addEventListener("click", function(event) {
    const item = event.target.closest(".color-item");
    if (!item) return;

    const card = item.closest(".product-card");
    if (!card) return;

    card.querySelectorAll(".color-item.is-active").forEach(function(other) {
      other.classList.remove("is-active");
    });

    item.classList.add("is-active");

    const primaryImage = card.querySelector(".product-card__media .product-card__image--primary");
    const secondaryImage = card.querySelector(".product-card__media .product-card__image--secondary");

    const primarySrc = item.getAttribute("data-variant-media");
    const secondarySrc = item.getAttribute("data-variant-secondary-media");

    if (primaryImage && primarySrc) {
      primaryImage.src = primarySrc;
      primaryImage.srcset = "";
    }

    if (secondaryImage && secondarySrc) {
      secondaryImage.src = secondarySrc;
      secondaryImage.srcset = "";
    }
  });

  document.addEventListener("change", function(event) {
    const radio = event.target.closest('[name^="metalware-"]');
    if (!radio) return;

    const card = radio.closest(".product-card");
    if (!card) return;

    const selectedMetalware = radio.value;

    card.querySelectorAll(".color-item").forEach(function(item) {
      const match = item.getAttribute("data-metalware") === selectedMetalware;
      item.classList.toggle("hidden", !match);
      item.classList.toggle("visible", match);
    });

    const firstVisible = card.querySelector('.color-item[data-metalware="' + selectedMetalware + '"]:not(.hidden)');
    if (firstVisible) firstVisible.click();
  });
}

document.addEventListener("DOMContentLoaded", function() {
  window.MarguetProductCards.init();
});

document.addEventListener("shopify:section:load", function() {
  window.MarguetProductCards.init();
});

document.addEventListener("facet:update", function() {
  window.MarguetProductCards.init();
});